export default __webpack_public_path__ + "static/media/icon-cal-date.5a59ad2a.svg";